<template>
    <Combobox v-model="selectedOption" as="div" nullable>
        <div class="relative mt-1">
            <ComboboxInput
                    v-bind="attrs"
                    v-model="selectedOption"
                    @input="query = $event.target.value"
                    class="block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-500 sm:text-sm"
            />
            <ComboboxButton class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-hidden" aria-label="Expand Button">
                <ChevronUpDownIcon aria-hidden="true" class="h-5 w-5 text-gray-400"/>
            </ComboboxButton>

            <ComboboxOptions v-if="filteredOptions"
                             class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm">
                <ComboboxOption v-for="option in filteredOptions" :key="option" v-slot="{ active, selected }" :value="option"
                                as="template">
                    <li :class="['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-electric-600 text-white' : 'text-gray-900']">
            <span :class="['block truncate', selected && 'font-semibold']">
              {{ option }}
            </span>

                        <span v-if="selected"
                              :class="['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-electric-600']">
              <CheckIcon aria-hidden="true" class="h-5 w-5"/>
            </span>
                    </li>
                </ComboboxOption>
            </ComboboxOptions>
        </div>
    </Combobox>
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed,useAttrs,defineProps, defineEmits, ref} from "vue";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOption,
    ComboboxOptions,
} from '@headlessui/vue';
import {CheckIcon, ChevronUpDownIcon} from '@heroicons/vue/20/solid';

defineOptions({ inheritAttrs: false })

const  props = defineProps({
  options: {
    type: Array,
    default: []
  },
  modelValue: {
    type: String,
    required: false,
    default: ""
  },
})
const query = ref('');
const emit = defineEmits(['update:modelValue', 'update:options'])
const attrs = useAttrs();

const options = computed({
  get: () => props.options,
  set: (val) => emit('update:options', val)
});

const selectedOption = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const filteredOptions = computed(() => {
    if (query.value === '') {
        return options.value;
    } 
    else {
        let matchedOptions = options.value.filter((option: string) => {
            return option.toLowerCase().includes(query.value.toLowerCase())
        });
        if(matchedOptions?.length > 0) {
            return matchedOptions;
        }

        return options.value;
    }
});
</script>